import AcademicPeriod from "./academic-period";
import Degree from "./degree";
import SubjectGroup from "./subject-group";
import Subject from "./subject";

export default {
  namespaced: true,
  modules: {
    AcademicPeriod,
    Degree,
    SubjectGroup,
    Subject
  }
}
